import { Tooltip } from 'antd';
import { useAntNotification } from 'components/ant/AntNotification';
import { Button } from 'components/UI';
import React from 'react';
import { useRolesRequestPermissionMutation } from 'utils/graphql/mutations/__generated__/rolesRequestPermission';

interface AccessRequestLinkProps {
  linkText?: string;
  group?: string;
  action?: string;
}

export const AccessRequestLink: React.FC<AccessRequestLinkProps> = ({
  linkText = 'Please fill the form to request access',
  group,
  action,
}) => {
  const notification = useAntNotification();

  const [rolesRequestPermission, { loading }] = useRolesRequestPermissionMutation();

  const canRequest = Boolean(group && action);

  const handleClick = async () => {
    if (!group || !action) {
      return;
    }

    try {
      const result = await rolesRequestPermission({
        variables: {
          input: {
            permissionGroup: group,
            permissionAction: action,
          },
        },
      });

      if (result.errors?.length) {
        notification.error({ message: result.errors[0]?.message ?? 'Failed to request access' });

        return;
      }

      if (result.data?.rolesRequestPermission?.ok) {
        notification.success({ message: 'Access request has been submitted' });
      } else {
        notification.error({ message: 'Failed to request access' });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const button = (
    <Button
      type="link"
      loading={loading}
      disabled={!canRequest}
      onClick={() => void handleClick()}
      style={{ padding: 0, height: 'auto' }}
    >
      {linkText}
    </Button>
  );

  if (!canRequest) {
    return (
      <Tooltip title="Permission could not be determined">
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
